import { Button, Grid, TextField } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import useToast from "hooks/useToast";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const Authentication = () => {
  const navigate = useNavigate();
  const toast = useToast();

  const form = useForm({
    defaultValues: {
      phone: "",
      password: "",
    },
  });

  const { mutate: handleLogin, isLoading: isSubmitting } = useMutation({
    mutationFn: (data) =>
      axios.post(`${process.env.REACT_APP_BASE_URL}/login/`, data),
    onSuccess: (response) => {
      localStorage.setItem("token", JSON.stringify(response?.data?.token));
      navigate("/app/dashboard");
      window.location.reload();
    },
    onError: (error) => {
      if (error?.response?.status === 400) {
        toast.show("error", "Invalid phone or password, Please try again");
      } else if (error?.response?.data?.isAdmin === false) {
        toast.show("error", `You don't have access to this domain`);
      } else {
        toast.show("error", "Something went wrong, Please try again later");
      }
    },
  });

  return (
    <form onSubmit={form.handleSubmit((values) => handleLogin(values))}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{
          height: "100vh",
          width: "100vw",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            backgroundImage: `url(${process.env.PUBLIC_URL}/Logos/landing-screen.jpg)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "blur(5px)",
          }}
        ></div>
        <Grid
          item
          xs={12}
          sm={8}
          md={4}
          style={{
            textAlign: "center",
            backgroundColor: "white",
            padding: "30px",
            borderRadius: "8px",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
            position: "relative",
          }}
        >
          <img
            src="https://gridkey.in/Logos/Gridkey_BrandGuidelines-removebg-preview.png"
            alt=""
            width="280"
            height="80"
          />
          <Controller
            name="phone"
            control={form.control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Phone"
                variant="outlined"
                fullWidth
                margin="normal"
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: 1,
                }}
              />
            )}
          />
          <Controller
            name="password"
            control={form.control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Password"
                type="password"
                variant="outlined"
                fullWidth
                margin="normal"
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: 1,
                }}
              />
            )}
          />

          <Button
            variant="contained"
            color="primary"
            fullWidth
            style={{ marginTop: "20px" }}
            disabled={isSubmitting}
            type="submit"
          >
            login
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default Authentication;
